import React from 'react';
import { MedicalDataTypes } from '../../../../../../primary-record-types';
import ResourceSearch from '../../../../../shared/ResourceSearch/ResourceSearch';
import ResourceListCard from '../../../../../shared/ResourceSearch/ResourceListCard';
import { useProfilesTabNavigation } from '../../../../../../utils/appNavigationNames';
import { getIntl } from '../../../../../../utils/intl';
import { ActionButtonLayout } from '../../../../../v2BaseComponents/ActionButtonLayout';

const intl = getIntl('linked-list-v2', {
    addLink: 'Add / Link',
});

export type LinkedListOwnProps = {
    sourceResourceCategory: MedicalDataTypes.PrimaryRecordResourceCategory;
    relatedResourceCategory: MedicalDataTypes.PrimaryRecordResourceCategory;
    hasEditPermission: boolean;
    relatedResources: MedicalDataTypes.PrimaryRecordResource[];
    isLoadingRelatedResources: boolean;
    profileId: string;
    sourceResourceId: string;
    onLink: () => void;
};

export type LinkedListProps = LinkedListOwnProps;

const LinkedList: React.FC<LinkedListProps> = ({
    relatedResourceCategory,
    relatedResources,
    isLoadingRelatedResources,
    profileId,
    hasEditPermission,
    onLink,
}) => {
    const navigation = useProfilesTabNavigation();
    return (
        <ActionButtonLayout
            actions={[
                {
                    title: intl('addLink'),
                    onPress: onLink,
                    icon: 'PlusCircle',
                    testID: 'add-link-button',
                    show: hasEditPermission,
                },
            ]}
        >
            <ResourceSearch
                category={relatedResourceCategory}
                resources={relatedResources || []}
                isLoadingResources={isLoadingRelatedResources}
                disableDetailedSearch
                linkEmptyStateHint
                renderFilteredResources={(resource) => (
                    <ResourceListCard
                        isSelectable={false}
                        resource={resource}
                        category={relatedResourceCategory}
                        profileId={profileId}
                        onNavigateToDetails={() => {
                            navigation.navigate('data-details', {
                                profileId,
                                category: relatedResourceCategory,
                                resourceId: resource.id,
                            });
                        }}
                    />
                )}
            />
        </ActionButtonLayout>
    );
};

export default React.memo(LinkedList);
